import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01f4b410&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&id=01f4b410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4b410",
  null
  
)

export default component.exports